import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroInstrumentador from "../../CadastroInstrumentador/index.tsx";

const CadastroInstrumentadorModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      title="Cadastro de Instrumentador"
      onClose={onClose}
    >
      <CadastroInstrumentador onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroInstrumentadorModal;
